export default __webpack_public_path__ + "static/media/mysql.b1d73c6b.png";